import { render, staticRenderFns } from "./select-folder.vue?vue&type=template&id=9df51706&scoped=true&"
import script from "./select-folder.vue?vue&type=script&lang=js&"
export * from "./select-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df51706",
  null
  
)

export default component.exports